export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-foursquare-ed0a2a45250480360da1a5ae8c1a0e3f.svg";